window.TizuAromaQuizOpen = function () {
  document.querySelector('.tizu-quiz-overlay')?.remove();

  const state = {
    cats: null,
    boxes: null,
    vulnerable: null,
    intensity: null,
    pain: null
  };

  const scents = {
    grandRosso: {
      name: 'Grand Rosso',
      tag: 'Aroma de Autor',
      desc: 'Floral dulce y envolvente. Ideal para hogares con varios Miuth y olor fuerte.',
      conc: 'Concentración alta'
    },
    soleil: {
      name: 'Soleil de Bianc',
      tag: 'Aroma de Autor',
      desc: 'Fresco y luminoso. Ideal para uno o dos Miuths.',
      conc: 'Concentración media'
    },
    uva: {
      name: 'Uva',
      tag: 'Aroma Esencial',
      desc: 'Frutal vibrante. Ideal para varios Miuths y olor fuerte.',
      conc: 'Concentración alta'
    },
    talco: {
      name: 'Talco de Bebé',
      tag: 'Aroma Esencial',
      desc: 'Limpio y suave. Ideal para rutinas de olor moderado.',
      conc: 'Concentración media'
    },
    neutra: {
      name: 'Neutra',
      tag: 'Sin aroma',
      desc: 'Muy ligera, con una sutil nota a café claro. Ideal para Miuths bebés, mayores o sensibles.',
      conc: 'Concentración muy baja'
    }
  };

  function getRecommendation() {
    if (state.vulnerable === 'yes') return scents.neutra;

    if (state.cats === '4+' || state.intensity === 'fuerte') {
      if (state.pain === 'olor' || state.pain === 'todas') return scents.grandRosso;
      return scents.uva;
    }

    if (state.intensity === 'medio') {
      if (state.pain === 'olor') return scents.soleil;
      return scents.talco;
    }

    if (state.intensity === 'suave') return scents.talco;

    return scents.soleil;
  }

  function getPresentation() {
    const cats = state.cats === '4+' ? 4 : Number(state.cats || 1);
    const boxes = state.boxes === '3+' ? 3 : Number(state.boxes || 1);
    const factor = cats * (1 + 0.08 * (boxes - 1));
    const daysLow = Math.round(35 / factor);
    const daysHigh = Math.round(45 / factor);

    let presentation = 'Individual';
    let frequency = 'cada mes';

    if (factor > 1.2 && factor <= 2.4) {
      presentation = 'Pack x4';
      frequency = 'cada 2 meses';
    }

    if (factor > 2.4) {
      presentation = 'Caja x8';
      frequency = 'cada 2 a 3 meses';
    }

    return { daysLow, daysHigh, presentation, frequency };
  }

  const html = `
    <div class="tizu-quiz-overlay">
      <div class="tizu-quiz-modal">
        <button type="button" class="tizu-quiz-close">×</button>

        <div class="tizu-quiz-header">

    <div class="tizu-header-top">

        <span class="tizu-quiz-eyebrow">
            TIZU · TU ARENA IDEAL
        </span>

        <span class="tizu-quiz-count">
            01 — 05
        </span>

    </div>

    <div class="tizu-quiz-progress">

        <span></span>

    </div>

</div>

        <div class="tizu-step is-active" data-step="1">
          <h3>¿Cuántos Miuths usan el arenero?</h3>
          <p>Para calibrar la intensidad de tu aroma.</p>
          <button type="button" data-question="cats" data-value="1">Un Miuth</button>
          <button type="button" data-question="cats" data-value="2">Dos Miuths</button>
          <button type="button" data-question="cats" data-value="3">Tres Miuths</button>
          <button type="button" data-question="cats" data-value="4+">Cuatro o más</button>
        </div>

        <div class="tizu-step" data-step="2">
          <h3>¿Cuántos areneros tienes?</h3>
          <p>Así sabemos cuánto dura cada bolsa en tu casa.</p>
          <button type="button" data-question="boxes" data-value="1">Uno</button>
          <button type="button" data-question="boxes" data-value="2">Dos</button>
          <button type="button" data-question="boxes" data-value="3+">Tres o más</button>
          <button type="button" class="tizu-back" data-back="1">← Atrás</button>
        </div>

        <div class="tizu-step" data-step="3">
          <h3>¿Hay algún Miuth bebé, mayor o sensible?</h3>
          <p>Si lo hay, priorizamos aromas más discretos.</p>
          <button type="button" data-question="vulnerable" data-value="no">No, todos adultos y sanos</button>
          <button type="button" data-question="vulnerable" data-value="yes">Sí, al menos uno</button>
          <button type="button" class="tizu-back" data-back="2">← Atrás</button>
        </div>

        <div class="tizu-step" data-step="4">
          <h3>¿Cómo describirías el olor del arenero?</h3>
          <p>Piensa en tu rutina diaria junto al arenero.</p>
          <button type="button" data-question="intensity" data-value="fuerte">Fuerte</button>
          <button type="button" data-question="intensity" data-value="medio">Moderado</button>
          <button type="button" data-question="intensity" data-value="suave">Muy ligero</button>
          <button type="button" class="tizu-back" data-back="3">← Atrás</button>
        </div>

     <div class="tizu-step" data-step="5">
  <h3>Antes de TIZU, ¿cuál era tu mayor problema con la arena?</h3>
  <p>Para que veas primero lo que más te va a cambiar.</p>

  <button type="button" data-question="pain" data-value="olor" data-multi="true">Mal olor</button>
  <button type="button" data-question="pain" data-value="pega" data-multi="true">Se pegaba a las patas</button>
  <button type="button" data-question="pain" data-value="polvo" data-multi="true">Hacía mucho polvo</button>
  <button type="button" data-question="pain" data-value="compacta" data-multi="true">No compactaba o no duraba</button>
  <button type="button" data-question="pain" data-value="gusto" data-multi="true">Mi Miuth no la aceptó</button>
  <button type="button" data-question="pain" data-value="insectos" data-multi="true">Atraía insectos</button>
  <button type="button" data-question="pain" data-value="todas" data-multi="true">Todas las anteriores</button>
  <button type="button" data-question="pain" data-value="primera" data-multi="true">Es mi primera arena</button>

  <button type="button" class="tizu-pain-continue" style="display:none;">
    Continuar
  </button>

  <button type="button" class="tizu-back" data-back="4">← Atrás</button>
</div>

        <div class="tizu-step" data-step="6">
          <span class="tizu-quiz-eyebrow">Tu diagnóstico TIZU</span>
          <h3>Encontramos tu Arena Tizu y frecuencia ideal.</h3>

          <div class="tizu-result-card">
            <span class="tizu-result-tag"></span>
            <h2 class="tizu-result-name"></h2>
            <p class="tizu-result-desc"></p>
            <p class="tizu-result-conc"></p>
          </div>

          <div class="tizu-plan-card">
            <p><strong>⁠Rendimiento estimado:</strong> <span class="tizu-days"></span></p>
            <p><strong>Te recomendamos:</strong> <span class="tizu-presentation"></span></p>
            <p><strong>Frecuencia sugerida:</strong> <span class="tizu-frequency"></span></p>
          </div>

          <button type="button" class="tizu-select-aroma">Seleccionar este aroma</button>
          <button type="button" class="tizu-quiz-close-final">Cerrar</button>
        </div>
      </div>
    </div>
  `;

  document.body.insertAdjacentHTML('beforeend', html);
};

document.addEventListener('click', function (e) {
  const overlay = document.querySelector('.tizu-quiz-overlay');
  if (!overlay) return;

  if (
    e.target.closest('.tizu-quiz-close') ||
    e.target.closest('.tizu-quiz-close-final')
  ) {
    overlay.remove();
    return;
  }

  const backBtn = e.target.closest('.tizu-back');
  if (backBtn) {
    showStep(backBtn.dataset.back);
    return;
  }

const answerBtn = e.target.closest('[data-question]');
if (!answerBtn) return;

const question = answerBtn.dataset.question;
const value = answerBtn.dataset.value;
const currentStep = answerBtn.closest('.tizu-step');

window.tizuQuizState = window.tizuQuizState || {};

if (question === 'pain') {
  window.tizuQuizState.pain = window.tizuQuizState.pain || [];

  answerBtn.classList.toggle('is-selected');

  const selected = [...currentStep.querySelectorAll('button[data-question="pain"].is-selected')]
    .map(btn => btn.dataset.value);

  window.tizuQuizState.pain = selected;

  const continueBtn = currentStep.querySelector('.tizu-pain-continue');
  if (continueBtn) {
    continueBtn.style.display = selected.length ? 'block' : 'none';
  }

  return;
}

currentStep.querySelectorAll('button[data-question]').forEach(btn => {
  btn.classList.remove('is-selected');
});

answerBtn.classList.add('is-selected');

window.tizuQuizState[question] = value;

setTimeout(() => {
  if (question === 'cats') showStep(2);
  if (question === 'boxes') showStep(3);
  if (question === 'vulnerable') showStep(4);
  if (question === 'intensity') showStep(5);
}, 350);

});

document.addEventListener('click', function(e){
  const continueBtn = e.target.closest('.tizu-pain-continue');
  if (!continueBtn) return;

  e.preventDefault();
  e.stopPropagation();

  if (!window.tizuQuizState?.pain?.length) return;

  showResult(window.tizuQuizState);
});

function showStep(stepNumber) {
  document.querySelectorAll('.tizu-step').forEach(step => {
    step.classList.remove('is-active');
  });

  const nextStep = document.querySelector(`.tizu-step[data-step="${stepNumber}"]`);
  if (nextStep) nextStep.classList.add('is-active');

  const count = document.querySelector('.tizu-quiz-count');
  const fill = document.querySelector('.tizu-quiz-progress span');

  if (count && Number(stepNumber) <= 5) {
    count.textContent = `${String(stepNumber).padStart(2, '0')} — 05`;
  }

  if (fill && Number(stepNumber) <= 5) {
    fill.style.width = `${Number(stepNumber) * 20}%`;
  }
}

function showResult(state) {
  const scents = {
    grandRosso: {
      name: 'Grand Rosso',
      tag: 'Aroma de Autor',
      desc: 'Floral dulce y envolvente. Ideal para hogares con varios Miuth y olor fuerte.',
      conc: 'Concentración alta'
    },
    soleil: {
      name: 'Soleil de Bianc',
      tag: 'Aroma de Autor',
      desc: 'Fresco y luminoso. Ideal para uno o dos Miuths.',
      conc: 'Concentración media'
    },
    uva: {
      name: 'Uva',
      tag: 'Aroma Esencial',
      desc: 'Frutal vibrante. Ideal para varios Miuths y olor fuerte.',
      conc: 'Concentración alta'
    },
    talco: {
      name: 'Talco de Bebé',
      tag: 'Aroma Esencial',
      desc: 'Limpio y suave. Ideal para rutinas de olor moderado.',
      conc: 'Concentración media'
    },
    neutra: {
      name: 'Neutra',
      tag: 'Sin aroma',
      desc: 'Muy ligera, con una sutil nota a café claro. Ideal para Miuths bebés, mayores o sensibles.',
      conc: 'Concentración muy baja'
    }
  };

  let result = scents.soleil;

  if (state.vulnerable === 'yes') result = scents.neutra;
  else if (state.cats === '4+' || state.intensity === 'fuerte') {
result = state.pain?.includes('olor') || state.pain?.includes('todas')
      ? scents.grandRosso
      : scents.uva;
  } else if (state.intensity === 'medio') {
    result = state.pain?.includes('olor')
      ? scents.soleil
      : scents.talco;
  } else if (state.intensity === 'suave') {
    result = scents.talco;
  }

  const cats = state.cats === '4+' ? 4 : Number(state.cats || 1);
  const boxes = state.boxes === '3+' ? 3 : Number(state.boxes || 1);
  const factor = cats * (1 + 0.08 * (boxes - 1));
  const daysLow = Math.round(35 / factor);
  const daysHigh = Math.round(45 / factor);

  let presentation = 'Pack x4';
let frequency = 'cada 4 meses';

  if (factor > 1.2 && factor <= 2.4) {
    presentation = 'Pack x4';
    frequency = 'cada 2 meses';
  }

  if (factor > 2.4) {
    presentation = 'Caja x8';
    frequency = 'cada 2 a 3 meses';
  }

  document.querySelector('.tizu-result-tag').textContent = result.tag;
  document.querySelector('.tizu-result-name').textContent = result.name;
  document.querySelector('.tizu-result-desc').textContent = result.desc;
  document.querySelector('.tizu-result-conc').textContent = result.conc;
  document.querySelector('.tizu-days').textContent = `~${daysLow}–${daysHigh} días por bolsa`;
  document.querySelector('.tizu-presentation').textContent = presentation;
  document.querySelector('.tizu-frequency').textContent = frequency;

  window.tizuRecommendedAroma = result.name;

  showStep(6);
}

document.addEventListener('click', function (e) {
  const selectBtn = e.target.closest('.tizu-select-aroma');
  if (!selectBtn) return;

  e.preventDefault();
  e.stopPropagation();

  const aroma = window.tizuRecommendedAroma;
  if (!aroma) return;

  const aromaMap = {
    'Grand Rosso': 'Grand roso',
    'Soleil de Bianc': 'Soleil d bianc',
    'Talco de Bebé': 'Talco de bebé',
    'Neutra': 'Inoloro/Neutro',
    'Uva': 'Uva'
  };

  const shopifyValue = aromaMap[aroma] || aroma;
  const target = shopifyValue.trim().toLowerCase();

  // 1. Intentar seleccionar swatch visible
  const swatch = [...document.querySelectorAll('[data-swatch-item]')].find(item => {
    const value = (item.dataset.value || '').trim().toLowerCase();
    const text = (item.textContent || '').trim().toLowerCase();
    const title = (item.getAttribute('title') || '').trim().toLowerCase();

    return value === target || text === target || title === target;
  });

  if (swatch) {
    swatch.click();

    swatch.dispatchEvent(new Event('click', { bubbles: true }));
    swatch.dispatchEvent(new Event('change', { bubbles: true }));
    swatch.dispatchEvent(new Event('touchend', { bubbles: true }));
  }

  // 2. Forzar selección desde el select oculto de variantes
  setTimeout(() => {
    const variantSelect = document.querySelector('select[name="id"]');

    if (variantSelect) {
      const option = [...variantSelect.options].find(opt => {
        return opt.textContent.toLowerCase().includes(target);
      });

      if (option) {
        variantSelect.value = option.value;

        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        variantSelect.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }

      // ===== ENVIAR RESPUESTAS =====

  fetch("https://script.google.com/macros/s/AKfycby4r6L3LJ_0f0z58Ld9Cc3Hwj-35uwjbnyL_1xEvSCIEzKGdPlApGzkPtIi9UilW0a7Rw/exec", {
    method: "POST",
    mode: "no-cors",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      cats: window.tizuQuizState?.cats || "",
      boxes: window.tizuQuizState?.boxes || "",
      vulnerable: window.tizuQuizState?.vulnerable || "",
      intensity: window.tizuQuizState?.intensity || "",
      pain: window.tizuQuizState?.pain || [],
      recommendation: window.tizuRecommendedAroma || "",
      selected: window.tizuRecommendedAroma || ""
    })
  });

    // 3. Cerrar quiz
    document.querySelector('.tizu-quiz-overlay')?.remove();

    // 4. Scroll suave al selector
    document.querySelector('.t4s-swatch')?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });

  }, 300);
});